import React from 'react'
import config from './config.js'

export default function Failed() {
    return (
        <div className='Failed'>
            Depot unavailable. Try checking if the URL is correct. <br /><br /> If this is an error, please call us: {config.phone}
        </div>
    )
}